import {
  Box,
  Button,
  DialogContent,
  DialogContentText,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";

import { Flex } from "../flex";

import SaveIcon from "@mui/icons-material/SaveOutlined";
import { useEffect, useState } from "react";
import { MenuItem, Select, FormControl } from "@mui/material";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import UploadIcon from "@mui/icons-material/FileUploadOutlined";

import { downloadFile } from "./api";

import { marked } from "marked";

import DownloadButtons from "./downloadButton";
import NextButton from "./nextPopup";

import "../upload/file-upload.css";
import { signOut } from "firebase/auth";

import { UseSnackbar } from "../snackbar/snackbarContext";
import { auth } from "../../auth/firebase-config";

import { createCitations } from "@/utils/util";
import "@/components/chatpage/footer.css";

const Footer = ({
  document_name,
  setdocument_name,
  isEditable,
  covloader,
  loading,
  setLoading,
  setcovloader,
  parentgenerate,
  secondcall,
  version,
  setVersion,
  data1,
  button,
  conversation_id,
  value,
  alldocs,
  handlesetchat,
  save_dashboard,
  setsave_dashboard,
  gcs_generated_documents,
  setGcs_generated_documents,
  user_edit,
  citations,
  responseTime,
}: any) => {
  const [docname, setdocname] = useState("");
  const uniqueSectionParentPairs = [
    { section: "Needs", parentLabel: "Feature Needs with Rationale" },
    { section: "Usecases", parentLabel: "Use cases" },
    {
      section: "Requirements",
      parentLabel: "Feature Requirements with Rationale",
    },
    { section: "User_stories", parentLabel: "User Stories" },
    { section: "test_case_steps", parentLabel: "Test Case Steps" },
    {
      section: "Expected_results",
      parentLabel: "Acceptance Criteria & Expected Results",
    },
    { section: "parent_generation", parentLabel: "System Requirements" },
    { section: "Traceability", parentLabel: "End to End Traceability" },
  ];

  const navigate = useNavigate();

  const [selectedFile, setSelectedFiles] = useState([]);
  const showSnackbar = UseSnackbar();

  let download_text;
  try {
    download_text = JSON.parse(data1);
  } catch (error) {
    console.error("Error parsing data:", error);
    download_text = data1;
  }

  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [coverageopen, setcoverageopen] = useState(false);
  const [generateopen, setgenerateopen] = useState(false);

  const handleSave = () => {
    console.log("saving in dashboard");
    setOpen(true);
  };
  const handleSave1 = () => {
    setOpen1(true);
  };

  const versions = alldocs.map((doc) => ({
    gcs_url: doc.doc_url,
    document_version: doc.document_version,
    document_id: doc.id,
  }));

  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
      padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
      padding: theme.spacing(1),
    },
    "& .MuiDialog-paper": {
      padding: "1.5rem",
    },
  }));

  const VisuallyHiddenInput = styled("input")({
    overflow: "hidden",
  });

  const handleClose = () => {
    setOpen(false);
    setcoverageopen(false);
    setgenerateopen(false);
    setSelectedFiles([]);
    setfilename("");
    setnextopen(false);
  };
  const handleClose1 = () => {
    setOpen(false);
    setcoverageopen(false);
    setgenerateopen(false);
    setSelectedFiles([]);
    setfilename("");
    setnextopen(false);
    setdocname(document_name);
    setOpen1(false);
  };

  const handledialog = () => {
    setOpen(false);

    try {
      handleSaveVersion(document_name);
      setsave_dashboard(true);
    } catch {
      console("not able save ");
    }
  };

  const handledialog1 = () => {
    setOpen1(false);

    try {
      handleSaveVersion(document_name);
      setsave_dashboard(true);
      const section = getNextStep(value.section);
      navigate(`/upload?project_name=${value.project_name}&section=${section}`);
    } catch {
      console("not able save ");
    }
  };

  const getParentLabel = (section) => {
    const found = uniqueSectionParentPairs.find(
      (item) => item.section === section
    );
    return found ? found.parentLabel : null;
  };
  const getNextStep = () => {
    let section = {};
    uniqueSectionParentPairs.forEach((item, i) => {
      if (value.section === "parent_generation") {
        section = uniqueSectionParentPairs[3];
      }
      if (item.section === value.section) {
        section = uniqueSectionParentPairs[i + 1];
      }
    });
    return `Generate ${section.parentLabel}`;
  };

  const savedocfirebase = async (gcs_url, document_name) => {
    const API_URL = `${import.meta.env.VITE_API_URL}/Document`;
    const accessToken = localStorage.getItem("accessToken");
    const user_data = localStorage.getItem("user_data");

    const document = await alldocs.find(
      (doc) => parseFloat(doc.document_version) === parseFloat(version)
    );

    const documentData = {
      Document_id: document.id,
      conversations_id: conversation_id,
      doc_url: document.doc_url,
      document_name: docname,
      document_version: version,
      project_name: value.project_name,
      type: getParentLabel(value.section),
      user_id: JSON.parse(user_data).id,
      feedback: 1,
      save_dashboard: true,
      response_time: responseTime,
    };

    setdocument_name(docname);
    try {
      const response = await axios.put(API_URL, documentData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (response && response.status === 200) {
        showSnackbar("Document saved to dashboard successfully", "success");
      } else {
        throw new Error("Invalid response format");
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        signOut(auth)
          .then(() => {
            localStorage.removeItem("userInfo");
            localStorage.removeItem("accessToken");
            localStorage.removeItem("user_data");
            console.log("User signed out due to inactivity.");
          })
          .catch((signOutError) => {
            console.error("Error signing out:", signOutError);
          });
      } else {
        showSnackbar("Something Went Wrong! Please Try Again! ", "error");
        throw new Error(`Internal server error: ${error}`);
      }
    }
  };

  const handleSaveVersion = async (document_name) => {
    savedocfirebase(gcs_generated_documents, document_name);
  };

  const [selectedGcsUrl, setSelectedGcsUrl] = useState("");
  const [selecteddocumentid, setselecteddocumentid] = useState("");
  useEffect(() => {
    if (versions.length > 0 && !selecteddocumentid) {
      setselecteddocumentid(versions[0].document_id);
    }
  }, [versions, selecteddocumentid]);
  useEffect(() => {
    setdocname(document_name);
  }, [document_name]);

  const handleChange = (event) => {
    const selectedVersion = event.target.value;
    setVersion(selectedVersion);

    const selectedItem = versions.find(
      (item) => item.document_version === parseFloat(selectedVersion)
    );

    if (selectedItem) {
      setGcs_generated_documents(selectedItem.gcs_url);
      setSelectedGcsUrl(selectedItem.gcs_url);
      handleVersionSelect(selectedItem.gcs_url);
      setselecteddocumentid(selectedItem.document_id);
      showSnackbar(`Version switched to v ${selectedVersion}`, "success");
    }
  };

  const handleVersionSelect = async (gcsUrl) => {
    try {
      const res = await fetch_gcsdata(gcsUrl);

      if (res && res.content) {
        handlesetchat(res.content);
      } else {
        console.error("Failed to fetch data or response content is invalid");
      }
    } catch (error) {
      console.error("Error fetching GCS data:", error);
    }
  };

  const fetch_gcsdata = async (gcsurl) => {
    const accessToken = localStorage.getItem("accessToken");

    const API_URL = `${
      import.meta.env.VITE_API_URL
    }/get-file-content?file_path=${encodeURIComponent(gcsurl)}`;

    try {
      const response = await axios.post(API_URL, null, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        signOut(auth)
          .then(() => {
            localStorage.removeItem("userInfo");
            localStorage.removeItem("accessToken");
            localStorage.removeItem("user_data");
            console.log("User signed out due to inactivity.");
          })
          .catch((signOutError) => {
            console.error("Error signing out:", signOutError);
          });
      } else {
        if (error.response && error.response.status === 401) {
          signOut(auth)
            .then(() => {
              localStorage.removeItem("userInfo");
              localStorage.removeItem("accessToken");
              localStorage.removeItem("user_data");
              console.log("User signed out due to inactivity.");
            })
            .catch((signOutError) => {
              console.error("Error signing out:", signOutError);
            });
        } else {
          showSnackbar("Something Went Wrong! Please Refresh! ", "error");

          throw new Error(`Internal server error: ${error}`);
        }
      }
    }
  };
  const [nextopen, setnextopen] = useState(false);

  const handlenextnotsave = () => {
    handlegenerateparent();
  };

  function transformResponse(srs_url) {
    const attachments = {
      requirements: gcs_generated_documents,
      srs_file: srs_url,
      additional_files: [],
    };
    const user_data = localStorage.getItem("user_data");
    return {
      project_name: value.project_name,
      process: "resume",
      section: "requirements",
      message: "Generate Coverage Analysis",
      attachments: attachments,
      source_ids: [],
      display_message: false,
      conversation_id: conversation_id,
      user_id: JSON.parse(user_data).id,
      version_uri: "",
    };
  }

  const handlecoverage = () => {
    setcoverageopen(true);
  };

  const coveragedialog = async () => {
    setcoverageopen(false);
    setcovloader(true);
    const formData = new FormData();
    const accessToken = localStorage.getItem("accessToken");
    const userInfo = JSON.parse(localStorage.getItem("user_data"));
    const uuid = userInfo.id;

    const API_URL = `${import.meta.env.VITE_API_URL}/source-upload`;

    formData.append("project_name", value.project_name);
    formData.append("user_id", uuid);
    formData.append("doc_type", "Requirements");

    formData.append(`files`, selectedFile);

    formData.append(`file_types`, "SRS_document");

    try {
      const response = await axios.post(API_URL, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (
        response.data &&
        response.data.data &&
        response.data.data.length > 0
      ) {
        setLoading(true);
        const srs_url = response.data.data[0].data.doc_url;

        const transformedResponse = transformResponse(srs_url);
        showSnackbar(
          "Documents uploaded successfully and generating response",
          "success"
        );
        setSelectedFiles([]);
        setfilename("");
        try {
          await secondcall(transformedResponse);
        } catch (error) {
          showSnackbar("Something Went Wrong! Please Refresh...", "error");
          console.error("Error during second call:", error);
        } finally {
          setcovloader(false);
        }
      } else {
        setSelectedFiles([]);
        setfilename("");
        throw new Error("Invalid response format");
      }

      return response;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        signOut(auth)
          .then(() => {
            localStorage.removeItem("userInfo");
            localStorage.removeItem("accessToken");
            localStorage.removeItem("user_data");
            console.log("User signed out due to inactivity.");
          })
          .catch((signOutError) => {
            console.error("Error signing out:", signOutError);
          });
      } else {
        showSnackbar("Internal Server Error! Please Try Again!", "error");
        throw new Error(`Internal server error: ${error}`);
      }
      setSelectedFiles([]);
    } finally {
    }
  };

  const postSourceData = async (payload) => {
    const accessToken = localStorage.getItem("accessToken");
    const API_URL = `${import.meta.env.VITE_API_URL}/Source`;

    try {
      const response = await axios.post(API_URL, payload, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        signOut(auth)
          .then(() => {
            localStorage.removeItem("userInfo");
            localStorage.removeItem("accessToken");
            localStorage.removeItem("user_data");
            console.log("User signed out due to inactivity.");
          })
          .catch((signOutError) => {
            console.error("Error signing out:", signOutError);
          });
      } else {
        showSnackbar("Something Went Wrong! Please Refresh! ", "error");
        throw new Error(`Internal server error: ${error}`);
      }
    }
  };

  function transformgResponse(sr_url) {
    const attachments = {
      system_requirements: gcs_generated_documents,
      sr_file: sr_url,
      additional_files: [],
    };
    const user_data = localStorage.getItem("user_data");
    return {
      project_name: value.project_name,
      process: "resume",
      section: "parent_generation",
      message: "Generate Coverage Analysis",
      attachments: attachments,
      source_ids: [],
      display_message: false,
      conversation_id: conversation_id,
      user_id: JSON.parse(user_data).id,
      version_uri: "",
    };
  }

  const handlegenerate = () => {
    setgenerateopen(true);
  };

  const generatedialog = async () => {
    setgenerateopen(false);
    setcovloader(true);
    const formData = new FormData();
    const accessToken = localStorage.getItem("accessToken");
    const userInfo = JSON.parse(localStorage.getItem("user_data"));
    const uuid = userInfo.id;

    const API_URL = `${import.meta.env.VITE_API_URL}/source-upload`;

    formData.append("project_name", value.project_name);
    formData.append("user_id", uuid);
    formData.append("doc_type", "Generate parent");

    formData.append(`files`, selectedFile);

    formData.append(`file_types`, "SR_document");

    try {
      const response = await axios.post(API_URL, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (
        response.data &&
        response.data.data &&
        response.data.data.length > 0
      ) {
        setLoading(true);
        const sr_url = response.data.data[0].data.doc_url;

        showSnackbar(
          "Documents uploaded successfully and generating response",
          "success"
        );
        const transformedResponse = transformgResponse(sr_url);
        setSelectedFiles([]);
        setfilename("");
        try {
          await secondcall(transformedResponse);
        } catch (error) {
          console.error("Error during second call:", error);
        } finally {
          setcovloader(false);
        }
      } else {
        setSelectedFiles([]);
        setfilename("");
        throw new Error("Invalid response format");
      }

      return response;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        signOut(auth)
          .then(() => {
            localStorage.removeItem("userInfo");
            localStorage.removeItem("accessToken");
            localStorage.removeItem("user_data");
            console.log("User signed out due to inactivity.");
          })
          .catch((signOutError) => {
            console.error("Error signing out:", signOutError);
          });
      } else {
        showSnackbar("Internal Server Error! Please Try Again!", "error");
        throw new Error(`Internal server error: ${error}`);
      }
      setSelectedFiles([]);
    } finally {
    }
  };

  const handlegenpopup = () => {
    if (!save_dashboard && !user_edit && document_name === "") {
      setnextopen(true);
    } else {
      handlegenerateparent();
    }
  };

  const handlegenerateparent = () => {
    const attachments = {
      requirements: gcs_generated_documents,
      additional_files: [],
    };
    const user_data = localStorage.getItem("user_data");
    const payload = {
      doc_url: gcs_generated_documents,
      is_generated: false,
      project_name: value.project_name,
      source_type: "requirements",
      title: "Title",
      user_id: JSON.parse(user_data).id,
    };
    postSourceData(payload)
      .then((data) => {
        console.log(data);
        console.log(data.data.id);

        const source_id = data.data.id;

        const transformedResponse = {
          project_name: value.project_name,
          process: "init",
          section: "parent_generation",
          message: "Generate system requirements",
          attachments: attachments,
          source_ids: [source_id],
          display_message: false,
          conversation_id: "",
          user_id: JSON.parse(user_data).id,
          version_uri: "",
        };

        showSnackbar("Generating parent response", "success");
        navigate("/generateparent", { state: { transformedResponse } });
        s;
      })
      .catch((error) => console.error(error));
  };

  const [filename, setfilename] = useState("");
  const filetypes = [
    "application/pdf",
    "text/plain",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];
  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      handleFiles(file);
    }
  };

  const handleFiles = (file) => {
    if (!filetypes.includes(file.type)) {
      showSnackbar("File types allowed: pdf, txt, doc, docx.", "error");
      return;
    }

    if (file.size > 10000000) {
      showSnackbar("File size limit is 10MB.", "error");
      return;
    }

    setSelectedFiles(file);
    setfilename(file.name);
  };

  const handledownload = () => {
    let html_code = marked(download_text);
    console.log("citations:", citations);

    const citationList = createCitations(download_text?.SourceFiles);

    if (citationList.length > 0) {
      let citationsHtml = "<h3>Sources:</h3><ul>";
      citationList.forEach((citation) => {
        citationsHtml += `<li>${citation.source} (Page: ${
          citation.pages?.toString() || "N/A"
        })</li>`;
      });
      citationsHtml += "</ul>";
      html_code += citationsHtml;
    }
    downloadFile(html_code, "xlsx", value);
  };

  const [dragging, setDragging] = useState(false);

  const formatFileName = (name) => {
    if (name.length > 20) {
      return `${name.slice(0, 16)}...${name.slice(-5)}`;
    }
    return name;
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setDragging(true);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const selectedfiles = Array.from(event.dataTransfer.files);

    handleFiles(selectedfiles[0]);
    setDragging(false);
  };

  const handleDragLeave = () => {
    setDragging(false);
  };

  return (
    <>
      <Flex
        sx={{ justifyContent: "space-between" }}
        className="footer-container"
      >
        <Flex sx={{ gap: 2, height: "inherit" }}>
          <FormControl sx={{ width: 310 }}>
            <Select
              sx={{ fontSize: "16px", fontWeight: "bolder" }}
              value={version}
              disabled={!download_text || user_edit || isEditable || loading}
              onChange={handleChange}
              displayEmpty
              renderValue={(selected) => {
                if (selected === "") {
                  return "Versions Control";
                }
                return `v ${selected}`;
              }}
            >
              {versions.map((type) => (
                <MenuItem
                  sx={{ fontSize: "16px", fontWeight: "bolder" }}
                  key={type.document_version}
                  value={type.document_version}
                >
                  {`v ${type.document_version}`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Flex>
        {!parentgenerate && (
          <Flex sx={{ gap: 2, p: 1 }}>
            <Button
              sx={{ textTransform: "capitalize", fontSize: "1rem" }}
              disabled={!download_text || user_edit || loading || covloader}
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={() => handleSave()}
            >
              Save to dashboard
            </Button>
            {button && (
              <Button
                sx={{ textTransform: "capitalize", fontSize: "1rem" }}
                disabled={!download_text || user_edit || loading || covloader}
                variant="contained"
                onClick={() => handlecoverage()}
              >
                Coverage Analysis
              </Button>
            )}
            {button && (
              <Button
                sx={{ textTransform: "capitalize", fontSize: "1rem" }}
                disabled={!download_text || user_edit || loading || covloader}
                variant="contained"
                onClick={() => handlegenpopup()}
              >
                Generate Parent
              </Button>
            )}
            {value.section !== "Traceability" && (
              <NextButton
                handleSave1={handleSave1}
                loading={loading}
                download_text={download_text}
                project_name={value.project_name}
                value={value}
                getNextStep={getNextStep}
                user_edit={user_edit}
                covloader={covloader}
                document_name={document_name}
              />
            )}
            <DownloadButtons
              loading={loading}
              download_text={download_text}
              value={value}
              covloader={covloader}
              document_name={document_name}
              citations={citations}
            />
          </Flex>
        )}
        {parentgenerate && (
          <Flex sx={{ gap: 2, p: 1 }}>
            <Button
              sx={{ textTransform: "capitalize", fontSize: "1rem" }}
              disabled={!download_text || user_edit || loading || covloader}
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={() => handleSave()}
            >
              Save to dashboard
            </Button>
            <Button
              sx={{ textTransform: "capitalize", fontSize: "1rem" }}
              disabled={!download_text || user_edit || loading || covloader}
              variant="contained"
              onClick={() => handlegenerate()}
            >
              Coverage Analysis
            </Button>
            <NextButton
              handleSave1={handleSave1}
              loading={loading}
              download_text={download_text}
              project_name={value.project_name}
              value={value}
              getNextStep={getNextStep}
              user_edit={user_edit}
              covloader={covloader}
              document_name={document_name}
            />
            <DownloadButtons
              loading={loading}
              download_text={download_text}
              value={value}
              covloader={covloader}
              document_name={document_name}
              citations={citations}
            />
          </Flex>
        )}
      </Flex>

      <Dialog
        open={open}
        onClose={handleClose1}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <IconButton
          aria-label="close"
          onClick={handleClose1}
          sx={{
            position: "absolute",
            right: 8,
            top: 1,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <br />
            <Box sx={{ minWidth: 120 }}>
              <FormControl fullWidth>
                <div style={{ width: "30rem" }}>
                  <Typography variant="normal" sx={{ fontSize: "1rem" }}>
                    Save your changes to the document?
                  </Typography>
                  <br />
                  <br />
                  <TextField
                    fullWidth
                    id="outlined-basic"
                    label="Document Name"
                    variant="outlined"
                    value={docname}
                    onChange={(e) => setdocname(e.target.value)}
                  />
                </div>
              </FormControl>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row-reverse",
              gap: "1rem",
              width: "100%",
            }}
          >
            <Button
              onClick={handledialog}
              variant="contained"
              autoFocus
              disabled={docname === ""}
              sx={{ backgroundColor: "#137d00", textTransform: "capitalize" }}
            >
              Yes
            </Button>
            <Button
              onClick={handleClose1}
              variant="contained"
              autoFocus
              sx={{ backgroundColor: "#137d00", textTransform: "capitalize" }}
            >
              No
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      <Dialog
        open={open1}
        onClose={handleClose1}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <IconButton
          aria-label="close"
          onClick={handleClose1}
          sx={{
            position: "absolute",
            right: 8,
            top: 1,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <br />
            <Box sx={{ minWidth: 120 }}>
              <FormControl fullWidth>
                <div style={{ width: "30rem" }}>
                  <Typography variant="normal" sx={{ fontSize: "1rem" }}>
                    Save your changes to the document?
                  </Typography>
                  <br />
                  <br />
                  <TextField
                    fullWidth
                    id="outlined-basic"
                    label="Document Name"
                    variant="outlined"
                    value={docname}
                    onChange={(e) => setdocname(e.target.value)}
                  />
                </div>
              </FormControl>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row-reverse",
              gap: "1rem",
              width: "100%",
            }}
          >
            <Button
              onClick={handledialog1}
              variant="contained"
              autoFocus
              disabled={docname === ""}
              sx={{ backgroundColor: "#137d00", textTransform: "capitalize" }}
            >
              Yes
            </Button>
            <Button
              onClick={handleClose1}
              variant="contained"
              autoFocus
              sx={{ backgroundColor: "#137d00", textTransform: "capitalize" }}
            >
              No
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      <Dialog
        open={coverageopen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 1,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <br />
            <Box
              component="label"
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={(event) => handleDrop(event)}
              sx={{ minWidth: 120 }}
            >
              <FormControl fullWidth>
                <div style={{ width: "20rem" }}>
                  <Box className="small-box" sx={{ ml: 5 }}>
                    <Typography
                      variant="h6"
                      sx={{ fontSize: "1rem", fontWeight: "bold" }}
                    >
                      Load SRS document *
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{
                        fontSize: "0.8rem",
                        fontWeight: "bold",
                        color: "red",
                      }}
                    >
                      (Required)
                    </Typography>
                    <IconButton component="label">
                      <input
                        type="file"
                        accept={filetypes}
                        value={""}
                        hidden
                        onChange={(event) => handleFileChange(event)}
                      />
                      <UploadIcon fontSize="medium" />
                    </IconButton>
                    <Typography sx={{ fontSize: "1rem" }}>
                      Click to{" "}
                      <span className="browse-text" sx={{ fontSize: "1rem" }}>
                        browse
                      </span>{" "}
                      or
                    </Typography>
                    <Typography sx={{ fontSize: "1rem" }}>
                      drag and drop your files
                    </Typography>
                  </Box>
                  {filename === "" ? (
                    <Typography
                      sx={{
                        ml: 15,
                        mt: 0.5,
                        color: "red",
                        padding: "0",
                        fontSize: "1rem",
                      }}
                    >
                      No file selected
                    </Typography>
                  ) : (
                    <Typography
                      className="filename-txt"
                      sx={{
                        ml: 10,
                        mt: 0.5,
                        color: "green",
                        padding: "0.1rem",
                        fontSize: "1rem",
                      }}
                    >
                      {formatFileName(filename)}
                    </Typography>
                  )}
                </div>
              </FormControl>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Box sx={{ ml: 10, width: "100%" }}>
            <Button
              onClick={coveragedialog}
              variant="contained"
              autoFocus
              disabled={selectedFile.length === 0}
              sx={{ backgroundColor: "#137d00", textTransform: "capitalize" }}
            >
              Generate Coverage Analysis
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
      {/* generate parent dialog box */}
      <Dialog
        open={generateopen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 1,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <br />
            <Box
              component="label"
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={(event) => handleDrop(event)}
              sx={{ minWidth: 120 }}
            >
              <FormControl fullWidth>
                <div style={{ width: "20rem" }}>
                  <Box className="small-box" sx={{ ml: 5 }}>
                    <Typography
                      variant="h6"
                      sx={{ fontSize: "1rem", fontWeight: "bold" }}
                    >
                      Load SR document *
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{
                        fontSize: "0.8rem",
                        fontWeight: "bold",
                        color: "red",
                      }}
                    >
                      (Required)
                    </Typography>
                    <IconButton component="label">
                      <input
                        type="file"
                        accept={filetypes}
                        value={""}
                        hidden
                        onChange={(event) => handleFileChange(event)}
                      />
                      <UploadIcon fontSize="medium" />
                    </IconButton>
                    <Typography sx={{ fontSize: "1rem" }}>
                      Click to{" "}
                      <span className="browse-text" sx={{ fontSize: "1rem" }}>
                        browse
                      </span>{" "}
                      or
                    </Typography>
                    <Typography sx={{ fontSize: "1rem" }}>
                      drag and drop your files
                    </Typography>
                  </Box>
                  {filename === "" ? (
                    <Typography
                      sx={{
                        ml: 15,
                        mt: 0.5,
                        color: "red",
                        padding: "0",
                        fontSize: "1rem",
                      }}
                    >
                      No file selected
                    </Typography>
                  ) : (
                    <Typography
                      className="filename-txt"
                      sx={{
                        ml: 10,
                        mt: 0.5,
                        color: "green",
                        padding: "0.1rem",
                        fontSize: "1rem",
                      }}
                    >
                      {formatFileName(filename)}
                    </Typography>
                  )}
                </div>
              </FormControl>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Box sx={{ ml: 10, width: "100%" }}>
            <Button
              onClick={generatedialog}
              variant="contained"
              autoFocus
              disabled={selectedFile.length === 0}
              sx={{ backgroundColor: "#137d00", textTransform: "capitalize" }}
            >
              Generate Coverage Analysis
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
      <Dialog
        open={nextopen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 1,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <br />
            <Box sx={{ minWidth: 120 }}>
              <FormControl fullWidth>
                <div style={{ width: "30rem" }}>
                  <Typography variant="normal" sx={{ fontSize: "1rem" }}>
                    Make sure you have saved your document,or else it will be
                    lost. Are you sure you want to proceed?
                  </Typography>
                  <br />
                  <br />
                </div>
              </FormControl>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row-reverse",
              gap: "1rem",
              width: "100%",
            }}
          >
            <Button
              onClick={handlenextnotsave}
              variant="contained"
              autoFocus
              sx={{ backgroundColor: "#137d00", textTransform: "capitalize" }}
            >
              Proceed
            </Button>
            <Button
              onClick={handleClose}
              variant="contained"
              autoFocus
              sx={{ backgroundColor: "#137d00", textTransform: "capitalize" }}
            >
              No
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Footer;
